import Honeybadger from '@honeybadger-io/js';

import { clearAccessToken, setAccessToken } from '../../utils/accessTokenStore';
import { deserializer } from '../../utils/deserializer';
import refreshClient from './client';

const AUTH_TOKENS = '/api/v1/auth/tokens';

// A placeholder for callbacks defined in the <AuthProvider />. Must be defined here, so
// that they can be used below.
let sessionHandlers = {
  onExpired: null, // Invoked when a session expires (i.e. logout).
  onRefreshed: null, // Invoked after a refresh succeeds.
};

export const registerSessionHandlers = (handlers) => {
  sessionHandlers = { ...sessionHandlers, ...handlers };
};

const performRefresh = async () => {
  try {
    const response = await refreshClient.post(AUTH_TOKENS);
    const accessToken = response.headers.authorization;

    setAccessToken(accessToken);

    const entity = await deserializer.deserialize(response.data);

    sessionHandlers.onRefreshed?.({ entity });

    return accessToken;
  } catch (error) {
    if (error.response?.status === 401) {
      clearAccessToken();
      sessionHandlers.onExpired?.();
    } else {
      Honeybadger.notify(error);
    }

    throw error;
  }
};

let refreshPromise = null;

export const refreshAccessToken = () => {
  if (!refreshPromise) {
    refreshPromise = performRefresh().finally(() => {
      refreshPromise = null;
    });
  }

  return refreshPromise;
};

export const revokeRefreshToken = async () => {
  try {
    await refreshClient.delete(AUTH_TOKENS);
  } catch (error) {
    Honeybadger.notify(error);
  }
};
